<template>
  <div class="layout">
    <gl-layout-header :msg="headerTitle" :user-name="userName" :actives="actives"></gl-layout-header>
    <div class="layout-content">
      <transition name="fade" mode="out-in">
        <router-view :key="key"></router-view>
      </transition>
    </div>
    <gl-layout-footer></gl-layout-footer>
  </div>
</template>

<script>
import GlLayoutHeader from './Header'
import GlLayoutFooter from './Footer'

export default {
  name: 'GlLayout',
  componentName: 'GlLayout',
  props: {
    headerTitle: String,
    userName: String,
    actives: Object
  },
  components: {
    GlLayoutHeader,
    GlLayoutFooter
  },
  computed: {
    key() {
      return this.$route + +new Date()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Index.vue